import { render, staticRenderFns } from "./WatchingListPage.vue?vue&type=template&id=435bffe2"
import script from "./WatchingListPage.vue?vue&type=script&lang=js"
export * from "./WatchingListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports